import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      // Update URL with clean path
      window.history.pushState(null, '', `/${sectionId}`);
    }
  };

  return (
    <footer id="contact" className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>Profit Pioneers</h3>
              <p>Accounting & Bookkeeping Inc.</p>
            </div>
            <p className="footer-description">
              Expert Canadian tax and accounting solutions serving across Canada.
              Professional, reliable, and trusted by hundreds of satisfied clients.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('home')} className="footer-link">Home</button></li>
              <li><button onClick={() => scrollToSection('about')} className="footer-link">About Us</button></li>
              <li><button onClick={() => scrollToSection('services')} className="footer-link">Services</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="footer-link">Contact Us</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Corporate Services</h4>
            <ul className="footer-links">
              <li><a href="/services/incorporation" className="footer-link">Business Incorporation</a></li>
              <li><a href="/services/bookkeeping" className="footer-link">Bookkeeping Services</a></li>
              <li><a href="/services/wsib-filing" className="footer-link">WSIB Filing</a></li>
              <li><a href="/services/payroll" className="footer-link">Payroll Services</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Tax Services</h4>
            <ul className="footer-links">
              <li><a href="/services/taxation" className="footer-link">Taxation</a></li>
              <li><a href="/services/gst-hst" className="footer-link">GST/HST Filing</a></li>
              <li><a href="/services/financial-planning-consultation" className="footer-link">Financial Planning & Consultation</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Advisory</h4>
            <div className="advisory-services">
              <div className="advisory-item">Valuation</div>
              <div className="advisory-item">Estate Planning</div>
              <div className="advisory-item">Forecasting & Budgeting</div>
            </div>
          </div>

          
        </div>

        {/* Contact info inline strip above FAQ */}
        <div className="contact-inline">
          <div className="contact-inline-list">
            <div className="contact-inline-item">
              <span className="contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V21a1 1 0 01-1 1C11.4 22 2 12.6 2 1a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"/>
                </svg>
              </span>
              <a href="tel:+14379287760" className="contact-link">+1 437-928-7760</a>
            </div>
            <div className="contact-inline-item">
              <span className="contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </span>
              <a href="mailto:Profitpioneersinfo@gmail.com" className="contact-link">Profitpioneersinfo@gmail.com</a>
            </div>
            <div className="contact-inline-item">
              <span className="contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                </svg>
              </span>
              <span className="contact-address">28 Grand Circuit Court, Brampton, ON L6Y 1A4</span>
            </div>
            <div className="contact-inline-item">
              <span className="contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.93 6h-3.26a15.46 15.46 0 00-1.3-3.35A8.03 8.03 0 0118.93 8zM12 4c.83 0 2.33 1.9 3.01 4H8.99C9.67 5.9 11.17 4 12 4zM4.07 8a8.03 8.03 0 014.56-3.35A15.46 15.46 0 007.33 8H4.07zM4 12c0-.69.07-1.35.2-2h3.45c-.09.65-.15 1.32-.15 2s.06 1.35.15 2H4.2A8.41 8.41 0 014 12zm.07 4h3.26c.3 1.18.74 2.34 1.3 3.35A8.03 8.03 0 014.07 16zM12 20c-.83 0-2.33-1.9-3.01-4h6.02C14.33 18.1 12.83 20 12 20zm3.29-.65c.56-1.01 1-2.17 1.3-3.35h3.26a8.03 8.03 0 01-4.56 3.35zM16.35 12c0-.68-.06-1.35-.15-2h3.45c.13.65.2 1.31.2 2s-.07 1.35-.2 2h-3.45c.09-.65.15-1.32.15-2zM7.65 12c0 .68.06 1.35.15 2H4.35A8.558 8.558 0 014.15 12c0-.68.06-1.35.2-2h3.45c-.09.65-.15 1.32-.15 2zM12 8c1.27 0 2.45.1 3.54.27.17.78.26 1.6.26 2.45s-.09 1.67-.26 2.45A25.87 25.87 0 0112 16a25.87 25.87 0 01-3.54-.27A9.96 9.96 0 018.2 12c0-.85.09-1.67.26-2.45A25.87 25.87 0 0112 8z"/>
                </svg>
              </span>
              <a href="https://www.profitpioneersinfo.com" target="_blank" rel="noreferrer" className="contact-link">www.profitpioneersinfo.com</a>
            </div>
            <div className="contact-inline-item">
              <span className="contact-icon instagram-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </span>
              <a href="https://instagram.com/profit_pioneers_" target="_blank" rel="noreferrer" className="contact-link">@profit_pioneers_</a>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>What documents do I need for personal tax filing?</h4>
              <p>You'll need your T4 slips, receipts for deductions (e.g., medical or childcare expenses), and any other relevant financial documents. We can provide a full checklist during your consultation.</p>
            </div>
            <div className="faq-item">
              <h4>How long does it take to complete a corporate tax return?</h4>
              <p>This depends on the complexity of your business finances, but typically corporate tax returns are completed within 2 to 4 weeks.</p>
            </div>
            <div className="faq-item">
              <h4>What are your service fees?</h4>
              <p>Our fees vary depending on the services you need. Contact us for a personalized quote based on your requirements.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer - Full Width */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Profit Pioneers Accounting & Bookkeeping Inc. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
